export { api, apiClient, ApiError } from "./client";
export { authService } from "./auth";
export { patientsService } from "./patients";
export { appointmentsService } from "./appointments";
export { proceduresService } from "./procedures";
export { transactionsService } from "./transactions";
export { professionalsService } from "./professionals";
// Automotive vertical
export { vehiclesService } from "./vehicles";
export { estimatesService } from "./estimates";

export * from "./types";
